<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["study", "studyLinks"]),
  },
  mounted() {
    this.$nextTick(() => {
      if (window.jQuery) {
        window.jQuery(this.$el).find('[data-toggle="tooltip"]').tooltip();
      }
    });
  },
};
</script>

<i18n>
{
  "en": {},
  "fr": {},
  "de": {}
}
</i18n>
